/* HoganFinds theme scripts — small, dependency-free */
(function () {
  'use strict';

  // ---- Add to cart (AJAX with graceful fallback to normal form post) ----
  document.addEventListener('submit', async function (e) {
    const form = e.target.closest('form[data-product-form]');
    if (!form || !window.fetch) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    const original = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }
    try {
      const res = await fetch(window.routes.cart_add_url + '.js', {
        method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form)
      });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Could not add to bag');
      await refreshCartCount();
      showToast('Added to your bag');
      if (btn) { btn.innerHTML = 'In your bag ✓'; }
    } catch (err) {
      showToast(err.message || 'Something went wrong', true);
      if (btn) { btn.disabled = false; btn.innerHTML = original; }
    }
  });

  async function refreshCartCount() {
    try {
      const cart = await fetch(window.routes.cart_url + '.js').then(r => r.json());
      document.querySelectorAll('[data-cart-count]').forEach(el => {
        el.textContent = cart.item_count > 0 ? cart.item_count : '';
        el.dataset.count = cart.item_count;
      });
    } catch (e) {}
  }

  let toastTimer;
  function showToast(msg, isError) {
    const t = document.getElementById('CartToast');
    if (!t) return;
    t.querySelector('.toast__text').textContent = msg;
    t.querySelector('.toast__link').hidden = !!isError;
    t.hidden = false;
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => { t.hidden = true; }, 4200);
  }

  // ---- Product gallery thumbnails ----
  document.addEventListener('click', function (e) {
    const thumb = e.target.closest('[data-thumb]');
    if (!thumb) return;
    const gallery = thumb.closest('[data-gallery]');
    const main = gallery.querySelector('.js-main-image');
    main.src = thumb.dataset.full;
    main.srcset = thumb.dataset.srcset || '';
    main.alt = thumb.querySelector('img').alt;
    gallery.querySelectorAll('[data-thumb]').forEach(b => b.setAttribute('aria-current', b === thumb ? 'true' : 'false'));
  });

  // ---- Variant radio -> hidden id ----
  document.addEventListener('change', function (e) {
    const radio = e.target.closest('[data-variant-radio]');
    if (radio) {
      const form = radio.closest('form');
      form.querySelector('input[name="id"]').value = radio.value;
      const btn = form.querySelector('[type="submit"]');
      const available = radio.dataset.available === 'true';
      btn.disabled = !available;
      btn.innerHTML = available ? btn.dataset.addText : 'Sold';
      const price = document.querySelector('[data-product-price]');
      if (price && radio.dataset.price) price.innerHTML = radio.dataset.price;
    }
    // Auto-submit collection filters / sort
    const auto = e.target.closest('[data-auto-submit]');
    if (auto) auto.form ? auto.form.submit() : auto.closest('form').submit();
  });

  // ---- Cart quantity steppers ----
  document.addEventListener('click', function (e) {
    const step = e.target.closest('[data-qty-step]');
    if (!step) return;
    const input = step.parentElement.querySelector('input');
    const next = Math.max(0, (parseInt(input.value, 10) || 0) + parseInt(step.dataset.qtyStep, 10));
    input.value = next;
    input.form.submit();
  });

  // ---- Close menus with Escape ----
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    document.querySelectorAll('details[open]').forEach(d => d.removeAttribute('open'));
  });

  // ---- Close filter dropdowns when clicking elsewhere ----
  document.addEventListener('click', function (e) {
    document.querySelectorAll('details.filter[open]').forEach(d => { if (!d.contains(e.target)) d.removeAttribute('open'); });
  });
})();
